// extracted by mini-css-extract-plugin
module.exports = {"root":"search-input_root__xH19B","iconWrapper":"search-input_iconWrapper__qfdlD","input":"search-input_input__o1ZLZ"};